export default "__VITE_ASSET__b8fdd3c4__"